import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import FormData from './FormData';

import LayoutContent from '@/layout/Content';

const RegisterStaff = () => {
    const { t } = useTranslation();
    const [title, setTitle] = useState<string>(t('staff:create_staff'));

    return (
        <LayoutContent isBack={true} className="p-register-staff" title={`${t('staff:SALES_TOTAL')} / ${title}`}>
            <FormData setTitle={setTitle} />
        </LayoutContent>
    );
};

export default RegisterStaff;
